import type { ServerColDef } from '@cmg/data-grid';
import { createValueFormatter, formatters } from '@cmg/data-grid';

import type { InvestorFirmFragment } from '../graphql/__generated__';
import { getSalesCoverageNames } from './sales-coverage.model';
import { SalesCoverageCellRenderer } from './SalesCoverageCellRenderer';

export const valueFormatter = createValueFormatter<
  InvestorFirmFragment,
  InvestorFirmFragment['salesCoverage']
>({
  gridRow: ({ value }) => {
    return formatters.truncatedArrayValueFormatter(getSalesCoverageNames(value));
  },
});

export const salesCoverageColDef: ServerColDef<
  InvestorFirmFragment,
  InvestorFirmFragment['salesCoverage']
> = {
  field: 'salesCoverage',
  headerName: 'Sales Coverage',
  valueFormatter,
  cellRenderer: SalesCoverageCellRenderer,
  context: {
    sortFieldPath: 'salesCoverageDisplayValue',
    filterFieldPath: 'salesCoverage.some.employeeName',
  },
};
